<script lang="ts">
  import { onMount } from "svelte";
  import { push } from "svelte-spa-router";
  import { errorTracker, postWithJwt, translate, getWithJwt, serverlessRoutes } from "lib";
  import { dialogData, showAlert, trainerClientsStore, user } from "stores";
  import { ButtonComponent, RadioField } from "ui";

  let data: any;
  let users: any[] = [];
  let selectedUserId: number;

  const onSubmit = async (): Promise<void> => {
    try {
      const response = await postWithJwt(`${serverlessRoutes.TRAINER_CLIENT}/change-trainer`, {
        newTrainerId: selectedUserId,
        clientId: data.client.id,
      });

      $showAlert.color = "black";
      $showAlert.message = "Klijent uspesno dodeljen drugom treneru";

      // Remove the transferred client from the trainerClientsStore
      trainerClientsStore.remove([data.client.id]);

      // Close the dialog
      $dialogData.type = "";
      $dialogData.data = {};

      // If we're on the ProfileScreen, redirect to client list
      if (window.location.href.includes(`/profile/${data.client.id}`)) {
        await push("/clients/list");
      }
    } catch (error) {
      errorTracker.captureError(error, 'error', {
        context: "TransferToAnotherTrainer.onSubmit",
        metadata: {
          newTrainerId: selectedUserId,
          clientId: data.client.id
        }
      });
      $showAlert.color = "red-400";
      $showAlert.message = "Doslo je do greske pri dodeljivanju klijenta";
    }
  };

  onMount(async (): Promise<void> => {
    const response = await getWithJwt(serverlessRoutes.TRAINER_GROUP);
    users = response.data;
    users = users.filter(({id}): boolean => id !== $user.id);
  });

  export { data };
</script>

<div class="p-4 flex flex-col gap-4">
  <div class="text-center font-semibold">
    {translate("TRANSFER_TO_ANOTHER_TRAINER")}
  </div>

  <div class="h-80 pl-4 flex flex-col gap-4 overflow-y-scroll">
    {#each users as user}
      <RadioField value={user.id} bind:group={selectedUserId}>
        <div class="p-2 flex items-center border {
          user.id === selectedUserId ? "border-primary-500" : ""
        } rounded-md">
          <div class="h-16 w-16 mr-2 overflow-hidden flex items-center">
            <img class="rounded-full" src={user.avatarUrl} alt="Avatar" />
          </div>
          <div class="grow">
            {user.name}<br />
            {user.email}
          </div>
        </div>
      </RadioField>
    {/each}
  </div>

  <div class="flex justify-center">
    <ButtonComponent on:click={onSubmit}>{translate("ASSIGN")}</ButtonComponent>
  </div>
</div>
